/* RAQO motion + order bar (Yalla Build). No library. Transform/opacity only. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* Header: frosted once content scrolls under it (sentinel, no scroll listener) */
  var sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:8px;pointer-events:none';
  document.body.prepend(sentinel);
  new IntersectionObserver(function (e) { root.classList.toggle('raqo-scrolled', !e[0].isIntersecting); }).observe(sentinel);

  /* Scroll reveal: only for blocks that start below the fold, so nothing already visible ever blinks */
  if (!reduce && 'IntersectionObserver' in window) {
    var sel = 'main .product-card, main .collection-card-simple, main .promotion-banners__block, main .image-with-text__media, main .section-product-benefits__box-image';
    var fold = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.style.setProperty('--raqo-d', Math.min(n++ * 70, 280) + 'ms');
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.cart-drawer, .predictive-search, [aria-modal]')) return;
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('raqo-rv');
      io.observe(el);
    });
  }

  /* Spec tables in product descriptions: hide rows with no value, and section titles left with nothing under them */
  document.querySelectorAll('.product-description-wrapper table').forEach(function (t) {
    var rows = [].slice.call(t.querySelectorAll('tr'));
    var isHead = function (r) { var c = r.querySelectorAll('td,th'); var f = c[0]; return !!f && (f.tagName === 'TH' || parseInt(getComputedStyle(f).fontWeight, 10) >= 600 || !!f.querySelector('strong,b')); };
    var hasVal = function (r) { var c = r.querySelectorAll('td,th'); return c.length >= 2 && c[c.length - 1].textContent.trim() !== ''; };
    rows.forEach(function (r) { if (!hasVal(r) && !isHead(r)) r.classList.add('raqo-row-empty'); });
    rows.forEach(function (r, i) {
      if (!isHead(r) || hasVal(r)) return;
      var j = i + 1, any = false;
      while (j < rows.length && !(isHead(rows[j]) && !hasVal(rows[j]))) { if (!rows[j].classList.contains('raqo-row-empty')) any = true; j++; }
      if (!any) r.classList.add('raqo-row-empty');
    });
  });

  /* Category banner and product description: long text folds on phones, with "Lire la suite" */
  document.querySelectorAll('.collection-header__description, .product-description-wrapper').forEach(function (d) {
    if (d.textContent.trim().length < 160) return;
    d.classList.add('raqo-clamp');
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'raqo-more'; b.textContent = 'Lire la suite'; b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = d.classList.toggle('is-open');
      b.textContent = open ? 'Réduire' : 'Lire la suite';
      b.setAttribute('aria-expanded', String(open));
    });
    d.after(b);
  });

  /* EasySell draws its order buttons in bright #FF6900 with white text (contrast 2.9:1, below the 4.5:1 minimum).
     Re-colour them to RAQO orange (4.8:1) and keep them that way if the app redraws. */
  (function raqoBrandButtons() {
    var paint = function () {
      document.querySelectorAll('#es-form-button, #es-form-container .es-cta-btn').forEach(function (b) {
        if (b.id === 'es-sticky' || b.dataset.raqoPainted) return;
        b.style.setProperty('background', '#B85A16', 'important');
        b.style.setProperty('border-color', '#B85A16', 'important');
        b.style.setProperty('border-radius', '10px', 'important');
        b.dataset.raqoPainted = '1';
      });
      /* WhatsApp button: bright green text on white was hard to read (about 2:1). Dark outline instead */
      document.querySelectorAll('#es-form-container [id^="es-whatsapp"]').forEach(function (b) {
        if (b.dataset.raqoPainted) return;
        b.style.setProperty('background', '#fff', 'important');
        b.style.setProperty('border', '1.5px solid #1A1512', 'important');
        b.style.setProperty('border-radius', '10px', 'important');
        b.style.setProperty('color', '#1A1512', 'important');
        b.querySelectorAll('*').forEach(function (c) { c.style.setProperty('color', '#1A1512', 'important'); });
        b.dataset.raqoPainted = '1';
      });
    };
    /* Order form texts: no ".00" on CFA prices, and a clean call-back note */
    var tidy = function () {
      var box = document.querySelector('#es-form-container');
      if (!box) return;
      var w = document.createTreeWalker(box, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        if (/\d\.00\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\d{1,3}(?:[ ,.\u202f]\d{3})+)\.00\b/g, '$1');
      }
      box.querySelectorAll('.mb-2 p').forEach(function (p) {
        if (/RAPIDE/.test(p.textContent)) p.textContent = "Après ta commande, on t'appelle pour confirmer l'adresse et l'heure de livraison.";
      });
      /* Delivery zones: "Zone Cocody-Bingerville-Plateau" reads as "Cocody · Bingerville · Plateau",
         same-day notes in green. Display only: the order keeps the app's own rate name. */
      box.querySelectorAll('.shipping-name').forEach(function (el) {
        var t = el.textContent;
        if (!/^Zone\s/i.test(t)) return;
        t = t.replace(/^Zone\s+/i, '').replace(/Port[- ]Bou[eë]t/gi, 'Port‑Bouët').replace(/Grand[- ]Bassam/gi, 'Grand‑Bassam');
        el.textContent = t.split('-').map(function (w) { w = w.trim(); return w.charAt(0).toUpperCase() + w.slice(1); }).join(' · ');
      });
      box.querySelectorAll('.shipping-description').forEach(function (el) {
        el.classList.toggle('is-sameday', /jour même/i.test(el.textContent));
      });
      /* Same-day note shown once next to the title instead of under every zone */
      box.querySelectorAll('.es-shipping_options-group').forEach(function (g) {
        var same = !!g.querySelector('.shipping-description.is-sameday');
        if (g.classList.contains('raqo-sameday') !== same) g.classList.toggle('raqo-sameday', same);
      });
    };
    var watchForm = function () {
      var box = document.querySelector('#es-form-container');
      if (!box || box.dataset.raqoWatched) return;
      box.dataset.raqoWatched = '1'; tidy();
      new MutationObserver(function () { tidy(); }).observe(box, { childList: true, subtree: true, characterData: true });
    };
    paint(); watchForm();
    var mo = new MutationObserver(function () { paint(); watchForm(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  })();

  /* Product page: sticky "Commander" bar whenever the order form is off screen */
  /* Product cards on phones: there is no mouse to hover, so the cards in the middle of the screen (the row being
     looked at, middle half of the screen) fade between their first and second photo every 1.8 s, and stop once
     scrolled away. With reduced motion the photos swap without the fade. CSS: .raqo-flip-on / .raqo-flip in raqo-style.css */
  (function raqoCardFlip() {
    /* Touch phone detection: iPhones report "no hover", but many Samsung phones (S Pen, Air View) claim hover,
       so a finger-sized pointer or a small touchscreen also counts */
    var touch = window.matchMedia('(hover: none), (pointer: coarse)').matches ||
      (navigator.maxTouchPoints > 0 && Math.min(screen.width, screen.height) < 820);
    if (!touch || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('raqo-touch');
    var active = [], timer = null;
    var tick = function () {
      active.forEach(function (w) {
        var img = w.querySelector('.product-card__image-picture--hover img');
        if (!w.classList.contains('raqo-flip') && img && !img.complete) return; /* never fade to a photo still loading */
        w.classList.toggle('raqo-flip');
      });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var w = e.target, i = active.indexOf(w);
        if (e.isIntersecting) {
          w.classList.add('raqo-flip-on'); if (i < 0) active.push(w);
          var hi = w.querySelector('.product-card__image-picture--hover img');
          if (hi && hi.loading === 'lazy') hi.loading = 'eager'; /* hidden at opacity 0, the browser would never fetch it */
        }
        else { if (i > -1) active.splice(i, 1); w.classList.remove('raqo-flip'); }
      });
      if (active.length && !timer) timer = setInterval(tick, 1800);
      if (!active.length && timer) { clearInterval(timer); timer = null; }
    }, { rootMargin: '-25% 0px -25% 0px' });
    var watch = function () {
      document.querySelectorAll('.product-card__image-wrapper--with-hover:not([data-raqo-flip])').forEach(function (w) {
        w.setAttribute('data-raqo-flip', '1'); io.observe(w);
      });
    };
    watch();
    /* Cards added later (carousels, filters, "load more") get the same treatment */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return; queued = true;
      requestAnimationFrame(function () { queued = false; watch(); });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  if (!/\/products\//.test(location.pathname)) return;

  /* One title per product page: a first description heading that only repeats the product name is hidden */
  (function raqoDupTitle() {
    var h1 = document.querySelector('.product-title, main h1');
    var d = document.querySelector('.product-description-wrapper');
    if (!h1 || !d) return;
    var first = d.firstElementChild;
    while (first && first.tagName === 'DIV' && first.firstElementChild) first = first.firstElementChild;
    if (!first || !/^H[1-6]$/.test(first.tagName) || first.textContent.trim().length > 100) return;
    var words = function (s) {
      return (s.toLowerCase().match(/[a-zà-ÿ0-9]+/g) || []).filter(function (w, i, a) { return w.length > 2 && a.indexOf(w) === i; });
    };
    var t = words(h1.textContent), w = words(first.textContent);
    if (!t.length || !w.length) return;
    var share = w.filter(function (x) { return t.indexOf(x) > -1; }).length / w.length;
    var cover = t.filter(function (x) { return w.indexOf(x) > -1; }).length / t.length;
    var nums = function (s) { return s.match(/\d{2,}/g) || []; };
    var kind = t.filter(function (x) { return !/^\d+$/.test(x) && x.length >= 4; })[0];
    var sameNumber = nums(h1.textContent).some(function (n) { return nums(first.textContent).indexOf(n) > -1; });
    var dup = (share >= 0.5 && cover >= 0.5) ||               /* mostly the same words */
      (kind && w.indexOf(kind) > -1 && sameNumber) ||           /* same product word and same size, e.g. 229 */
      (share === 1 && w.length <= 4);                           /* a short heading made only of title words */
    if (dup) first.classList.add('raqo-dup-title');
  })();

  /* Gallery: pointing at a thumbnail with a mouse shows that photo right away (a tap still picks it on phones) */
  (function raqoThumbHover() {
    var row = document.querySelector('.product-media__slider-thumbnails');
    var main = document.querySelector('.product-media__slider');
    if (!row || !main) return;
    var timer;
    row.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var thumb = e.target.closest('.product-media__slider-thumbnails-slide');
      var sw = main.swiper;
      if (!thumb || !sw) return;
      var i = Array.prototype.indexOf.call(thumb.parentElement.children, thumb);
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (sw.params.loop) { if (sw.realIndex !== i) sw.slideToLoop(i, reduce ? 0 : 250); }
        else if (sw.activeIndex !== i) sw.slideTo(i, reduce ? 0 : 250);
      }, 40);
    });
  })();
  var tries = 0;
  (function waitForm() {
    var form = document.querySelector('#es-form-container');
    if (!form) { if (tries++ < 40) setTimeout(waitForm, 250); return; }
    var titleEl = document.querySelector('.product__title, .product-title, main h1');
    var priceEl = document.querySelector('.product-price .price__sale .price-item--sale, .product-price .price__regular .price-item--regular');
    var bar = document.createElement('div');
    bar.className = 'raqo-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.inert = true;
    bar.innerHTML = '<div class="raqo-buybar__info"><span class="raqo-buybar__title"></span><span class="raqo-buybar__price"></span></div>' +
      '<button type="button" class="raqo-buybar__btn">Commander</button>';
    bar.querySelector('.raqo-buybar__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var priceOut = bar.querySelector('.raqo-buybar__price');
    var syncPrice = function () { if (priceEl) priceOut.textContent = priceEl.textContent.trim(); };
    syncPrice();
    if (priceEl) new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    document.body.appendChild(bar);

    bar.querySelector('button').addEventListener('click', function (e) {
      var y = form.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      if (e.detail === 0) { var f = form.querySelector('input, select'); if (f) f.focus({ preventScroll: true }); }
    });

    var formSeen = false, pastTop = false;
    var update = function () {
      var show = !formSeen; /* visible from the first screen, hidden only while the real order button is on screen */
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.inert = !show;
    };
    /* Watch the order button itself, not the whole form: on phones the form's top edge reached the screen
       long before its button did, and the bar disappeared with no button in sight */
    var target = function () { return form.querySelector('.es-cta-btn') || form; };
    var watched = target();
    var formIO = new IntersectionObserver(function (e) { formSeen = e[0].isIntersecting; update(); }, { threshold: 0.5 });
    formIO.observe(watched);
    /* The order app can re-render its form: follow the new nodes */
    setInterval(function () {
      if (!form.isConnected) { var f = document.querySelector('#es-form-container'); if (f) form = f; }
      var t = target();
      if (t !== watched) { formIO.disconnect(); watched = t; formIO.observe(t); }
    }, 1000);
    var top = document.querySelector('.product-price') || form;
    new IntersectionObserver(function (e) { pastTop = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update(); }).observe(top);
  })();
})();
